export enum EModule {
    PlatformValidator = 'platform_validator',
    PreSignatureValidator = 'pre_signature_validator'
}
